import {useCallback, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {Button, Card, CardContent, Grid} from '@mui/material';
import {useRqGetDemoStingerById} from '../../../../react_query/demoStingerQuery';
import {IDemoScriptStateProp} from '../../../../dto/demoStingerFulfilment.dto';
import DemoStingerScriptSection from './DemoStingerScriptSection';
import {apiPost} from '../../../../axiosConfig';
import DialogApiRequestStatus from '../../../../components/dialogs/DialogApiRequestStatus';
import DemoStingerContent from './DemoStingerContent';

import DemoStingerStingerSection from './DemoStingerStingerSection';
import {broadCastCloseTab} from '../../../../react_query/tasks/ListTasks';
const DemoStingerAddScript = () => {
  const task = useParams();
  const taskId = Number(task.task_id);
  const {data, isError, isFetched} = useRqGetDemoStingerById(taskId);
  const [defaultScript, setDefaultScript] = useState<IDemoScriptStateProp[]>(
    [],
  );
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [apiState, setApiState] = useState({status: '', error: null});
  const [message, setMessage] = useState<IDemoScriptStateProp[]>([
    {
      id: Date.now(),
      name: '',
      file: null,
    },
    {
      id: Date.now() + 1,
      name: '',
      file: null,
    },
  ]);
  useEffect(() => {
    if (data && !isError && isFetched) {
      const scripts: IDemoScriptStateProp[] = [];
      data.default_stingers.forEach(val => {
        scripts.push({
          id: val.id,
          name: '',
          message: val.script,
        });
      });
      setDefaultScript(scripts);
    }
  }, [data, isError, isFetched]);
  useEffect(() => {
    const allValuesFilled = defaultScript.every(
      item => item.id && item.name && item.message,
    );
    const stinger = message.every(item => item.id && item.name && item.file);
    const validation =
      data?.values.category_option === 'Partner'
        ? allValuesFilled && stinger
        : allValuesFilled;
    setIsButtonDisabled(!validation);
  }, [defaultScript, message, data?.values.category_option]);
  const handleAdd = useCallback(() => {
    setDefaultScript(prevScripts => [
      ...prevScripts,
      {
        id: Date.now(),
        name: '',
        message: '',
      },
    ]);
  }, []);
  const handleDelete = useCallback(
    (id: number) => {
      const updatedScripts = defaultScript.filter(script => script.id !== id);
      setDefaultScript(updatedScripts);
    },
    [defaultScript],
  );
  const handleSubmit = useCallback(() => {
    const fd = new FormData();
    setApiState({
      status: 'pending',
      error: null,
    });
    fd.append(`type`, String(data?.values.category_option));
    fd.append(`demo_stinger_fulfilment_id`, String(data?.values.id));
    defaultScript.forEach((val, index) => {
      fd.append(`scripts[${index}][name]`, val.name);
      fd.append(`scripts[${index}][message]`, String(val.message));
    });
    if (data?.values.category_option === 'Partner') {
      message.forEach((val, index) => {
        fd.append(`stinger[${index}][name]`, val.name);
        if (val.file) {
          fd.append(`stinger[${index}][file]`, val.file);
        }
      });
    }
    apiPost(`/v1/task/${taskId}/demo-stinger`, fd)
      .then(() => {
        setApiState({
          status: 'success',
          error: null,
        });
        broadCastCloseTab();
      })
      .catch(error => {
        setApiState({
          status: 'error',
          error,
        });
      });
  }, [
    data?.values.id,
    defaultScript,
    taskId,
    data?.values.category_option,
    message,
  ]);
  const handleEdit = useCallback(() => {
    setApiState({
      status: '',
      error: null,
    });
  }, []);
  const handleCancel = useCallback(() => {
    window.close();
  }, []);
  return (
    <Card>
      <CardContent className='p-2'>
        {data && <DemoStingerContent values={data.values} />}
        <Grid container>
          <Grid item xs={data?.values.category_option === 'Partner' ? 6 : 12}>
            {defaultScript && (
              <DemoStingerScriptSection
                defaultScript={defaultScript}
                setDefaultScript={setDefaultScript}
                handleDelete={handleDelete}
                handleAdd={handleAdd}
              />
            )}
          </Grid>
          {data?.values.category_option === 'Partner' && (
            <Grid item xs={6}>
              <DemoStingerStingerSection
                message={message}
                setMessage={setMessage}
              />
            </Grid>
          )}
        </Grid>
        <Button
          className='float-right mr-10 my-5'
          variant='contained'
          disabled={isButtonDisabled}
          onClick={handleSubmit}>
          Submit
        </Button>
      </CardContent>
      {apiState.status !== '' && (
        <DialogApiRequestStatus
          onEdit={handleEdit}
          onRetry={handleSubmit}
          onClose={handleCancel}
          apiState={apiState}
        />
      )}
    </Card>
  );
};
export default DemoStingerAddScript;
